import axios from "axios";
import { API_BASE_PATH } from "../../environment";


const API_URL = `${API_BASE_PATH}/attendance/attendance/export`;

interface ExportParams {
  month: number;
  year: number;
  employee_id?: number;     // for single
  employee_ids?: number[]; 
}


export interface AttendanceRecord {
  [key: string]: string; 
  "Employee Name": string;
  "Employee ID": string;
}

interface AttendanceParams {
  month: number;
  year: number;
}



export const downloadAttendanceExport = async (params: ExportParams, token: string) => {
  try {
    const response = await axios.get(`${API_BASE_PATH}/attendance/attendance/export`, {
      params,
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "attendance.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error(err);
  }
};

export const fetchEmployeeAttendance = async (
  params: AttendanceParams,
  token: string
): Promise<AttendanceRecord[]> => {
  try {
    const response = await axios.get<AttendanceRecord[]>(
      `${API_BASE_PATH}/attendance/attendance/data/employee`,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching attendance data:", error);
    throw error;
  }
};